import { getUserInfo as getUserInfoService } from 'services/api/user/getUserInfo';
import * as constants from './constants';

const getUserInfo = (payload, params) => async dispatch => {
  const { email } = payload;
  const param = {...params, email};
  dispatch({ type: constants.GET_USER_INFO, email });
  try {
    const { errors, response } = await getUserInfoService({}, param);
    const userInfo = JSON.stringify(response);
    localStorage.setItem('getUserInfo', userInfo);
    if (errors?.error?.[0] === 'User not found') {
      dispatch(getUserInfoSuccess({ errors }));
      return true;
    }
    if(errors?.error?.[0] == 'error_params:parameter user_hash or email missing'){
      throw errors;
    }
    dispatch(getUserInfoFail({ error: 'missed user not found error' }));
    return false;
  } catch (error) {
    dispatch(getUserInfoFail({ error }));
    throw {};
  }
};

const getUserInfoSuccess = payload => dispatch => {
  dispatch({ type: constants.GET_USER_INFO_SUCCEEDED, payload });
};

const getUserInfoFail = payload => dispatch => {
  dispatch({ type: constants.GET_USER_INFO_FAILED, payload });
};

export {
  // action creators
  getUserInfo,
  getUserInfoSuccess,
  getUserInfoFail,
};
